'use client';
import Image from 'next/image';
import ModalForm from '../Modal/Modal';
import { ReactNode, useState } from 'react';
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import CustomRichText from '../CustomRichText';

interface GlobalVolunteerProps {
  id?: string;
  title?: ReactNode | SerializedEditorState;
  description?: ReactNode | SerializedEditorState;
  formatList?: Array<{
    icon: string;
    title: ReactNode | SerializedEditorState;
  }>;
  buttonText?: string;
  buttonTag?: string;
  images?: Array<{
    image: string | { url: string; alt: string };
    width: number;
    height: number;
  }>;
}

export default function GlobalVolunteer({
  id = 'global-volunteer',
  title = 'Програма Global Volunteer',
  description = 'Global Volunteer — міжнародна волонтерська програма, з якою ви можете допомагати в різних благодійних проєктах по всьому світу.',
  formatList = [
    { icon: '01', title: 'Робота над соціально значущими проєктами' },
    { icon: '02', title: 'Взаємодія з волонтерами з усього світу' },
    { icon: '03', title: 'Можливість побачити нові країни та культури' },
  ],
  buttonText = 'Приєднатися до Global Volunteer',
  buttonTag = 'університет-Global-Volunteer',
  images = [
    { image: { url: '/assets/icon/AIESEC.svg', alt: 'AIESEC' }, width: 550, height: 100 },
    { image: { url: '/assets/icon/GV.svg', alt: 'Global Volunteer' }, width: 550, height: 100 },
  ],
}: GlobalVolunteerProps) {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const openForm = () => setIsFormOpen(true);
  const closeForm = () => setIsFormOpen(false);

  return (
    <>
      <div
        id={id}
        data-meta="GlobalVolunteer"
        className="container max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 my-24"
      >
        <div className="flex flex-col xl:flex-row">
          <div className="flex flex-col justify-start">
            <CustomRichText
              data={title}
              tag="h2"
              className="text-3xl font-bold tracking-tight text-white sm:text-6xl mb-4 sm:mb-8"
            />
            <CustomRichText
              data={description}
              tag="div"
              className="mt-6 text-md lg:text-xl lg:leading-8 text-white"
            />
          </div>
          <div className="flex flex-col justify-between lg:flex-row xl:flex-col">
            {images.map((image, index) => (
              <Image
                key={index}
                src={typeof image.image === 'string' ? image.image : image.image.url}
                alt={typeof image.image === 'string' ? '' : image.image.alt}
                width={image.width}
                height={image.height}
              />
            ))}
          </div>
        </div>
        <div className="flex flex-col lg:flex-row lg:flex-wrap mt-2 lg:mt-8">
          {formatList.map((item, index) => (
            <div key={index} className={`flex flex-col flex-1 p-4 border-l-2 border-blue-100/15`}>
              <div className="p-4">
                <p className="font-bold text-6xl mb-4 text-white text-opacity-25">{item.icon}</p>
                <div className="mb-4">
                  <CustomRichText
                    data={item.title}
                    tag="div"
                    className="text-xl font-bold text-white"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="flex justify-center mt-8">
          <button
            onClick={openForm}
            className={`uppercase custom-gradient-blue-btn rounded-full px-8 py-2.5 text-center text-md font-fixel font-bold text-white shadow-sm focus-visible:outline`}
          >
            {buttonText}
          </button>
        </div>
      </div>

      {isFormOpen && (
        <ModalForm
          closeForm={closeForm}
          btnMeta={{
            tag: buttonTag,
          }}
          color={'blue'}
        />
      )}
    </>
  );
}
